import { jsx as _jsx } from "react/jsx-runtime";
export const RemoveIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "8",
        height: "7",
        viewBox: "0 0 8 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.34831 0.720257L6.67688 0.0488281L4.01497 2.71073L1.35307 0.0488281L0.681641 0.720257L3.34355 3.38216L0.681641 6.04407L1.35307 6.7155L4.01497 4.05359L6.67688 6.7155L7.34831 6.04407L4.6864 3.38216L7.34831 0.720257Z",
            fill: "black"
        })
    });
